var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompatiblewithallcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 46.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.94,21.79c5.31,0,10.63,0,15.94,0,2.56,0,3.7,1.11,3.71,3.69.02,3.96.02,7.92,0,11.87-.02,2.51-1.16,3.65-3.64,3.66-10.74,0-21.48.01-32.21,0-2.44,0-3.55-1.13-3.56-3.58-.01-4.03-.02-8.06,0-12.09.01-2.44,1.12-3.53,3.59-3.54,5.39-.01,10.77,0,16.16,0Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.47,0c5.59.03,10.02,4.55,9.94,10.16-.07,5.54-4.57,10-10.05,9.97-5.54-.03-9.97-4.57-9.94-10.18C26.46,4.4,30.93-.03,36.47,0Zm-5.79,10.03c0,3.28,2.48,5.82,5.72,5.84,3.11.02,5.81-2.67,5.82-5.8,0-3.21-2.57-5.81-5.77-5.83-3.19-.02-5.76,2.56-5.77,5.79Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.98,30.86c0,2.67,0,5.35,0,8.02,0,.42.16.94-.34,1.18-.43.2-.76-.15-1.08-.37-2.81-1.93-5.62-3.85-8.41-5.8-2.59-1.81-2.61-4.35-.04-6.15,2.82-1.98,5.66-3.91,8.5-5.86.32-.22.64-.59,1.08-.35.44.24.3.71.3,1.1,0,2.75,0,5.49,0,8.24Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.57,19.92c-4.25.02-7.51-3.26-7.55-7.61-.04-3.94,3.44-7.41,7.46-7.42,4.06-.01,7.49,3.42,7.49,7.49,0,4.19-3.27,7.52-7.4,7.54Zm3.61-7.48c.01-2.07-1.62-3.74-3.63-3.75-2.1,0-3.74,1.65-3.74,3.77,0,2,1.73,3.75,3.7,3.73,2-.02,3.66-1.72,3.67-3.76Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.92,46.09c-1.79,0-3.59-.01-5.38,0-.97.01-1.39-.4-1.39-1.39,0-.97.38-1.4,1.37-1.4,3.59.02,7.18.02,10.77,0,.93,0,1.34.41,1.35,1.32,0,.91-.3,1.47-1.33,1.46-1.79-.02-3.59,0-5.38,0Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.92,27.62c0,.73.01,1.46,0,2.19,0,.26-.11.51-.39.6-.29.09-.5-.09-.65-.3-1.22-1.64-2.47-3.27-3.64-4.94-.44-.63-.24-1.15.6-1.19.91-.04,1.83-.04,2.74-.02.94.02,1.25.7,1.33,1.46.08.72.02,1.46.02,2.19,0,0,0,0,0,0Z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.5,16.89c-.41-.14-.61-.37-.71-.76-.59-2.27-.98-2.63-3.26-3.03q-.36-.57-.15-1.2c.32-.3.74-.19,1.12-.29,1.26-.35,2.04-1.15,2.26-2.43.09-.53.11-1.02.76-1.18.44.02.74.25.78.7.2,2.03,1.44,2.94,3.3,3.06.51.44.53.84.08,1.31-.73.21-1.58.21-2.24.79-.59.51-.95,1.13-1.06,1.91-.07.51-.11,1.05-.87,1.13Zm.05-5.59c-.31.47-.81.68-.99,1.17.33.36.64.71.85.94.44-.37.81-.69,1.18-1-.35-.37-.67-.71-1.04-1.11Z",
    fill: "#f8f8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompatiblewithallcamera);
export default __webpack_public_path__ + "static/media/Compatible with all camera.efb732a17a74a52e0d1aa0c576467abf.svg";
export { ForwardRef as ReactComponent };